<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer v-if="appDrawerAccess.size > 1" :access="appDrawerAccess" />

    <dashboard-core-view />

    <dashboard-core-settings />
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import appAxios from '../../extra-functions/axios.extra'

export default {
  name: 'DashboardIndex',

  components: {
    DashboardCoreAppBar: () => import('./components/core/AppBar'),
    DashboardCoreDrawer: () => import('./components/core/Drawer'),
    DashboardCoreSettings: () => import('./components/core/Settings'),
    DashboardCoreView: () => import('./components/core/View'),
  },

  data: () => ({
    expandOnHover: false,
    appDrawerAccess: new Set(),
    listening: null,
  }),

  computed: {
    ...mapState({
      echo: state => state.websocket.echo,
      loggedIn: state => state.auth.loggedIn,
      token: state => state.auth.token,
    }),
  },
  created() {
    this.initEcho(this.token)
  },
  mounted() {
    this.channelListen()
    this.getAppDrawerAccess()
  },
  beforeDestroy() {
    this.echo.leaveChannel('database-update')
  },
  watch: {
    echo(val) {
      if (!val) return
      this.channelListen()
    },
  },
  methods: {
    ...mapActions({
      initEcho: 'websocket/initEcho',
      consumerUpdated: 'consumer/channelUpdated',
      consumerLoanUpdated: 'consumerLoan/channelUpdated',
      consumerLoanInventoryUpdated: 'consumerLoanInventory/channelUpdated',
      consumerLoanTransactionUpdated: 'consumerLoanTransaction/channelUpdated',
      stockTransferUpdated: 'stockTransfer/channelUpdated',
      unitUpdated: 'unit/channelUpdated',
      stockUpdated: 'stock/channelUpdated',
      supplierUpdated: 'supplier/channelUpdated',
      supplierProductUpdated: 'supplierProduct/channelUpdated',
      recievedInventoryUpdated: 'recievedInventory/channelUpdated',
      saleInventoryUpdated: 'saleInventory/channelUpdated',
      lostInventoryUpdated: 'lostInventory/channelUpdated',
      logout: 'auth/logout',
      userUpdated: 'user/channelUpdated',
      sessionExpired: 'auth/sessionExpired',
    }),
    async getAppDrawerAccess() {
      try {
        const axios = appAxios(this.token)
        const { data } = await axios.get('/user-access/app-drawer-access')
        const access = new Set([...data])
        this.appDrawerAccess = access
      } catch (e) {
        console.error(e)
        const confirm = await this.$confirm('oops something went wrong retry?')
        if (confirm) {
          this.getAppDrawerAccess()
        }
      }
    },
    channelListen() {
      // this.echo.channel('test.event')
      //   .listen('TestEvent', e => { console.log(e) })
      if (!this.echo) throw new Error('echo is null')
      this.echo.channel('database-update')
        .listen('UnitUpdate', this.cbUnitUpdated)
        .listen('StockUpdate', this.cbStockUpdated)
        .listen('SupplierUpdate', this.cbSupplierUpdated)
        .listen('StockSupplierUpdate', this.cbSupplierProductUpdated)
        .listen('RecievedInventoryUpdate', this.cbRecievedInventoryUpdated)
        .listen('SaleInventoryUpdate', this.cbSaleInventoryUpdated)
        .listen('LostInventoryUpdate', this.cbLostInventoryUpdated)
        .listen('UserUpdated', this.cbUserUpdated)
        .listen('ConsumerUpdated', this.cbConsumerUpdated)
        .listen('ConsumerLoanUpdated', this.cbConsumerLoanUpdated)
        .listen('ConsumerLoanInventoryUpdated', this.cbConsumerLoanInventoryUpdated)
        .listen('ConsumerLoanTransactionUpdated', this.cbConsumerLoanTransactionUpdated)
        .listen('StockTransferUpdate', this.cbStockTransferUpdate)
      this.echo.channel('force-logout')
        .listen('ForceLogout', this.forceLogout)
    },

    forceLogout(e) {
      const regX = new RegExp('Bearer ', 'gi')
      let recToken = ''
      if (regX.test(e.logout)) {
        recToken = e.logout.replace(regX, '')
      }

      if (this.loggedIn && recToken === this.token) {
        this.sessionExpired()
        this.logout()
      }
    },

    cbUserUpdated(e) {
      this.userUpdated()
    },
    cbSupplierProductUpdated(e) {
      this.supplierProductUpdated()
    },
    cbRecievedInventoryUpdated(e) {
      this.recievedInventoryUpdated()
    },
    cbSaleInventoryUpdated(e) {
      this.saleInventoryUpdated()
    },
    cbLostInventoryUpdated(e) {
      this.lostInventoryUpdated()
    },
    cbUnitUpdated(e) {
      this.unitUpdated()
    },
    cbStockUpdated(e) {
      this.stockUpdated()
    },
    cbSupplierUpdated(e) {
      this.supplierUpdated()
    },
    cbConsumerUpdated(e) {
      this.consumerUpdated()
    },
    cbConsumerLoanUpdated(e) {
      this.consumerLoanUpdated()
    },
    cbConsumerLoanInventoryUpdated(e) {
      this.consumerLoanInventoryUpdated()
    },
    cbConsumerLoanTransactionUpdated(e) {
      this.consumerLoanTransactionUpdated()
    },
    cbStockTransferUpdate(e) {
      this.stockTransferUpdated()
    },
  },
}
</script>
